import api from '@/os/APIs/osAPI';

export default {
  install: (app) => {
    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$os = api;
  },
};
